import { CompartmentCard } from "@/src/components/cards";
import { InfoGrid } from "@/src/components/infoGrid";
import { Patient } from "@/src/data/allTypes";
import { formatDate, getAge } from "@/src/utils/utils";
import Barcode from "react-barcode";
import {
  openPatientIdentityDrawer
} from "./patientIdentityForm";

function PatientIdentity({
  patient,
  onChange,
}: {
  patient: Patient;
  onChange?: (newValue: Patient) => void;
}) {
  console.log("patient", patient);
  return (
    <CompartmentCard
      title={"Etat civil"}
      buttonTitle="Modifier"
      onClick={async () => {
        await openPatientIdentityDrawer({
          patient,
          onChange: (newValue) => {
            patient = newValue;
            onChange?.(newValue);
          },
        });
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "20px",
          height: "100%",
        }}
      >
        <div className="grid c1 gap10">
          <InfoGrid name="Identifiant" value={<div className="bold blue-bg lc">{patient.shortId?.toUpperCase()}</div>}></InfoGrid>
          <InfoGrid name="Nom" value={patient.lastName}></InfoGrid>
          <InfoGrid name="Prénom" value={patient.firstName}></InfoGrid>
          <InfoGrid name="Age" value={`${getAge(patient)}`}></InfoGrid>
          <InfoGrid
            name="Date de naissance"
            value={formatDate(patient.birth, "LL")}
          ></InfoGrid>
          <InfoGrid name="Tel" value={patient.phoneNumber}></InfoGrid>

          <InfoGrid name="Groupe sanguin" value={patient.bloodType}></InfoGrid>
          <InfoGrid name="Wilaya" value={patient.wilaya}></InfoGrid>
          <InfoGrid name="Adresse" value={patient.address}></InfoGrid>
          <InfoGrid name="Assurance" value={patient.assuranceAffiliation}></InfoGrid>
          <InfoGrid
            name="N° dossier papier"
            value={patient.recordId}
          ></InfoGrid>
        </div>
        <div className="center c1 gap5">
          <Barcode
            value={
              patient.nin ||
              patient.id?.replace("patients:", "")?.toString()?.slice(0, 8) ||
              ""
            }
            displayValue={false}
            height={30}
            width={1}
            fontSize={12}
            margin={0}
          ></Barcode>
          <div className="black  bold ">{patient.shortId?.toUpperCase()}</div>
          <div className=" bold blueish">{patient.nin}</div>
          <div className="gray">Créé le {formatDate(patient._date, "LL")}</div>
        </div>
      </div>
    </CompartmentCard>
  );
}

export { PatientIdentity };
